export default {
  dateToYMD: (date) => {
    if (!date) {
      return false
    }
    let d = date.split('.')
    if (d.length !== 3) {
      return false
    }
    return d[2] + '-' + d[1] + '-' + d[0]
  },

  firstLetterUppercase (str) {
    if (!str) { return '' }
    return str[0].toUpperCase() + str.substr(1).toLowerCase()
  },
}
